module.exports = __webpack_public_path__ + "media/partenaire/arrow_2-9b806c80.png";